export default __webpack_public_path__ + "static/media/windows.14155fa4.svg";